import React from 'react'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import AuditTrailsTable from '../../../common/AuditTrailsTable';
import { GetAssessemntAuditTrialCancelToken, GetAssessmentAuditTrialDropdownCancelToken, GetClassAttendanceAuditTrailCancelToken, GetClassAttendanceAuditTrailDropdownCancelToken } from '../../../../services/CourseService';
import { RenderCourseResourceType } from '../../../../utils/CommonGroupingItem';

function ClassAttendanceAuditTrail() {

  const { intake, cid: id } = useParams();

  const columnsToShow = ["Action Type", "Resource Type", "Resource Name"];

  const apiParams = {
    class_id: id,
  };

  const handleRedirect = (id, type, otherData) => {
    return `/courseAdministration/gradingTemplate/edit/${id}`;
  };

  return (
    <AuditTrailsTable
      apiFunction={GetClassAttendanceAuditTrailCancelToken}
      columnsToShow={columnsToShow}
      apiParams={apiParams}
      filterArrApi={GetClassAttendanceAuditTrailDropdownCancelToken}
      actionId={id}
      exportFileName={"Class_Attendance_Audittrails"}
      resourceNameRedirect={handleRedirect}
      isResourceNameShown={true}
      isShowingResourceTypeFilter
      renderResourceTypeFunction={RenderCourseResourceType}
    />
  )
}

export default ClassAttendanceAuditTrail